import React, { useEffect } from "react";
import "./style.css";
import { FaBalanceScale, FaGavel, FaAward } from "react-icons/fa";
import NewHeroSection from "../components/herosection";
import Categories from "../components/categories";
import Testimonials from "../components/testimonials";
import Blog from "../components/blog";
import StatsSection from "../components/Stats";
import HeroFooter from "../components/footer";
import aboutim from "../assets/images/aboutimg.jpg"
import paymentba from "../assets/images/BookCons.jpg"
import ScrollToTop from "./offerings/scrolltop";
import DisclaimerModal from "../components/disclaimer";

function Home() {
  useEffect(() => {
    const elements = document.querySelectorAll(".fade-in-left, .fade-in-right");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show"); // Trigger animation
            observer.unobserve(entry.target); // Stop observing once triggered
          }
        });
      },
      { threshold: 0.3 } // Trigger when 30% visible
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const elements = document.querySelectorAll(".fade-in");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show"); // Trigger animation
            observer.unobserve(entry.target); // Stop observing once triggered
          }
        });
      },
      { threshold: 0.3 } // Trigger when 30% visible
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div>
      <ScrollToTop/>
      <DisclaimerModal/>
      <section className="about-us" id="about">
        <div className="container aboutcont">
          <div className="image-container fade-in-left">
            <div className="image-box">
              <img src={aboutim} alt="InduRatna Law Associates" />
            </div>
          </div>

          <div className="content fade-in-right">
            <div className="about-title">
              <span className="icon-bg">
                <FaBalanceScale />
              </span>
              <h2>About Us</h2>
            </div>
            <p>
              <strong>InduRatna Law Associates</strong> is a renowned <span className="highlight">corporate law firm</span> based in
              Pimpri-Chinchwad, Pune, Maharashtra, India. Our firm specializes in providing <span className="highlight">legal solutions</span> in various fields:
            </p>
            <ul className="about-list">
              <li>✔ Corporate and Business Laws</li>
              <li>✔ Company Acquisitions & Mergers</li>
              
              <li>✔ International Collaborations & Agreements</li>
              <li>✔ Property Transfers & Succession Laws</li>
              <li>✔ Wills and Succession</li>
            </ul>
            <p className="ending-text">We strive to deliver the best legal services tailored to your needs.</p>
          </div>
        </div>
      </section>

      <section className="legal-highlights">
        <div className="container" >

          <div className="highlight-box fade-in">
            <div className="icon-wrapper">
              <FaGavel />
            </div>
            <h3>Legal Protection</h3>
            <p>Providing strong legal support for businesses and individuals to safeguard their rights.</p>
          </div>

          <div className="highlight-box fade-in">
            <div className="icon-wrapper">
              <FaBalanceScale />
            </div>
            <h3>Private Consultation</h3>
            <p>Exclusive one-on-one legal consultations to ensure personalized legal advice.</p>
          </div>

          <div className="highlight-box fade-in">
            <div className="icon-wrapper">
              <FaAward />
            </div>
            <h3>Winning Awards</h3>
            <p>Recognized for excellence in legal services with multiple prestigious awards.</p>
          </div>
        </div>
      </section>
      <div><NewHeroSection /></div>


      <div>
        <Categories />

        <div className="bookappointment" id="bookappointment">
        <img 
          src={paymentba} 
          className="bookappointmentimg" 
          alt="Book Appointment"
           
        />

        {/* Book Now Button */}
        
      </div>
        <div>
        <a
  href="https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ2_Mc65EfnAdZ7aqjw5flRhd4Unb10xUpnP6LOzctpj5G-oHkFCUQc9tPx8TI0ThbAo8u_cc4Aa"
  target="_blank"
  rel="noopener noreferrer"
>
  <button className="booknow-btn">
    Book Now
  </button>
</a>
        </div>

        <Testimonials />
        <Blog />
        <StatsSection />
        <HeroFooter />
      </div>






    </div>
  );
}

export default Home;
